import { DSCircularButton } from "@components/design-system/molecules";
import { UserPermissions } from "@hooks/use-premium-feature";
import type { useWritingAssistant } from "@hooks/use-writing-assistant";

import GatedQuillButton from "./GatedQuillButton";
import Twemoji from "../../../Twemoji";
import CascadingDropdown from "../menus/CascadingDropdown";
import PremiumFeatureGate from "../premium/PremiumFeatureGate";

interface WritingAssistantFieldActionsProps {
  wa: ReturnType<typeof useWritingAssistant>;
  sectionLabel: string;
  writingAssistant: boolean;
}

export default function WritingAssistantFieldActions({
  wa,
  sectionLabel,
  writingAssistant,
}: WritingAssistantFieldActionsProps) {
  if (wa.diffState) return null;

  return (
    <>
      {writingAssistant && (
        <PremiumFeatureGate
          featureName="Writing Assistant"
          requiredPermission={
            UserPermissions.WRITING_ASSISTANT_ENABLED
          }
          iconPosition="center"
          iconSize="xs"
        >
          <CascadingDropdown
            options={wa.options}
            setIsMenuOpen={wa.setIsMenuOpen}
            title={sectionLabel}
            isTriggerComponentDisabled={
              wa.loadingBeforeAndDuringStreaming
            }
            triggerComponent={({
              onClick,
            }: {
              onClick: () => void;
            }) => (
              <DSCircularButton
                onClick={onClick}
                size="sm"
                disabled={wa.loadingBeforeAndDuringStreaming}
                title="Trigger Writing Assistant"
                dataTestId="cascading-dropdown-trigger"
              >
                <Twemoji className="text-xl z-20" emoji="✨" />
              </DSCircularButton>
            )}
          />
        </PremiumFeatureGate>
      )}
      <GatedQuillButton />
    </>
  );
}
